(function () {
    'use strict';

    angular
        .module('app')
        .controller('CreateEditConcertController', CreateEditConcertController);

    CreateEditConcertController.$inject = ['$http', '$rootScope', '$stateParams', '$state', '$filter', '$scope', 'dateParser', 'dialog', 'countries', 'emojiReplacer', 'cache', 'localization', 'promoModule'];

    function CreateEditConcertController($http, $rootScope, $stateParams, $state, $filter, $scope, dateParser, dialog, countries, emojiReplacer, cache, localization, promoModule) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.no_scroll = true;
        var vm = this;
        vm.$onInit = init;
        vm.save = save;
        vm.softDelete = softDelete;
        vm.publish = publish;
        vm.validate_percentage_division = validate_percentage_division;
        vm.formIsValid = formIsValid;
        vm.validateDraft = validateDraft;
        vm.validatePublish = validatePublish;
        vm.getCurrencyMinimumPrice = getCurrencyMinimumPrice;
        vm.lowFiFee = 15;
        vm.royaltyFee = 10;
        vm.currencyConversionFee = 2;
        vm.calculateShares = calculateShares;
        vm.shares = {};
        vm.close = close;
        vm.royaltyFreeToggle = royaltyFreeToggle;
        vm.getPreviewState = getPreviewState;
        vm.lowFiFeeInfo = lowFiFeeInfo;
        vm.royaltyFeeInfo = royaltyFeeInfo;
        vm.currencyConversionFeeInfo = currencyConversionFeeInfo;
        vm.privateConcertInfo = privateConcertInfo;
        vm.noLowFiHostInfo = noLowFiHostInfo;
        vm.lowFiConditionsInfo = lowFiConditionsInfo;
        vm.noHostToggle = noHostToggle;
        vm.countries = countries;
        vm.showPreview = showPreview;
        vm.isConcertTimesValid = isConcertTimesValid;
        vm.isConcertEndTimeValid = isConcertEndTimeValid;
        vm.isConcertDoorTimeValid = isConcertDoorTimeValid;
        vm.getSpaceInfo = getSpaceInfo;
        vm.getBandInfo = getBandInfo;
        vm.goToPaymentInfo = goToPaymentInfo;
        vm.goToPaymentInfoDirect = goToPaymentInfoDirect;
        vm.hideSplashAndShowForm = hideSplashAndShowForm;
        vm.autofillMusician = autofillMusician;
        vm.autofillHost = autofillHost;
        vm.removeNoScroll = removeNoScroll;
        vm.copyLink = copyLink;
        vm.closeSharePopup = closeSharePopup;
        vm.selectImage = selectImage;
        vm.saveDraft = saveDraft;
        vm.getFeeVoucher = getFeeVoucher;

        $scope.$on('$destroy', function () {
            $rootScope.no_scroll = false;
        });

        function init() {
            getCurrencies();
            switch ($stateParams.language) {
                case 'da':
                    vm.datePlaceholder = 'DD.MM.ÅÅÅÅ'
                    break;
                case 'en':
                    vm.datePlaceholder = 'DD.MM.YYYY'
                    break;
                case 'sv':
                    vm.datePlaceholder = 'DD.MM.ÅÅÅÅ'
                    break;
            }
            vm.uiDateOptions = angular.copy($rootScope.uiDateConfig);
            vm.uiDateOptions.minDate = new Date();

            var unregister_uploaded_image_exists_event = $rootScope.$on('uploaded_image_exists', function (event, args) {
                if (args.type === 'concerts' && args.image_number == 1) {
                    vm.header_image_set = args.image_exists;
                }
            });
            $scope.$on('$destroy', unregister_uploaded_image_exists_event);

            var unregister_uploaded_image_temp = $rootScope.$on('uploaded_image_temp', function (event, args) {
                vm.upload_image_slug = args.temp_slug;
            });
            $scope.$on('$destroy', unregister_uploaded_image_temp);

            vm.slug = $stateParams.concert_slug;
            vm.band_slug = $stateParams.band_slug;
            vm.space_slug = $stateParams.space_slug;
            vm.concert = {};
            vm.concert.concert_band_percentage = 100 - vm.lowFiFee - vm.royaltyFee;
            vm.concert.concert_host_percentage = "0";
            vm.user_bands = [];
            vm.user_hosts = [];

            getUser();


            if (!vm.slug) {
                vm.concert.concert_public = 1;
                vm.concert.concert_ticket_handling_automatic = 1;
                vm.concert.concert_currency = 'dkk';
                vm.concert.selected_moods = [];
                vm.concert.concert_country = "DK"
                vm.concert.concert_published = 0;
                vm.slug = "new";
                vm.royaltyFreeConcert = 0;
                vm.no_host = false;

                if (vm.band_slug) {
                    getBandInfo(vm.band_slug).then(autofillMusician).then(getUserHostAndMusicianProfiles);
                }

                if (vm.space_slug) {
                    getSpaceInfo(vm.space_slug).then(autofillHost).then(getUserHostAndMusicianProfiles);
                }



                //vm.concert.concert_date = new Date();

            } else {
                getContent().then(function () {
                    getBandInfo(vm.concert.band.band_slug).then(function () { getUserHostAndMusicianProfiles(); });
                });
            }

            calculateShares();
            getCountryAdjective();
        }

        function autofillMusician(band) {
            if (!band) {
                band = vm.band;
            } else {
                vm.band = band;
            }
            vm.concert.concert_name = band.band_name;
            vm.concert.concert_video = band.band_youtube;
            vm.band_images = [];
            vm.band_images.push(vm.band.primary_image)
            vm.band_images = vm.band_images.concat(vm.band.secondary_images)
        }

        function autofillHost(host) {
            if (!host) {
                host = vm.space;
            } else {
                vm.space = host;
            }
            vm.concert.concert_ticket_no = parseInt(host.space_seat_no);
            if (host.space_country == "SE") {
                vm.concert.concert_currency = "sek"
            }
            getCountryAdjective();
        }

        $scope.$on("$locationChangeStart", function (event) {
            if (vm.ConcertForm.$dirty) {
                event.preventDefault();
                dialog.prompt('unsaved-changes-prompt', function (response) {
                    if (response.confirm) {
                        leave();
                    }
                }, true);
            }
        });

        function getUser() { //Gets information about the currently logged-in user
            $http.get('api/private/users/')
                .then(function (response) {
                    vm.user = response.data;
                    vm.server_name = response.data.server_name;
                    $rootScope.user_stripe_connection = response.data.user_stripe_connected_account_token;
                })
        }

        function goToPaymentInfo() {
            save().then(function () {
                $rootScope.no_scroll = false;
                $state.go('stripe_connect');
            });
        }
        function goToPaymentInfoDirect() {
            $rootScope.no_scroll = false;
            $state.go('stripe_connect');
        }

        function noHostToggle() {
            if (vm.no_host && vm.concert.space.space_slug) {
                vm.concert.space = {};
                vm.concert.concert_address = ""
                vm.concert.concert_city = "";
                vm.concert.concert_zip = "";
                noLowFiHostInfo();
            }
        }

        function isConcertEndTimeValid() {
            return moment(vm.concert.concert_start_time).isBefore(vm.concert.concert_end_time, "minutes")
        }

        function isConcertDoorTimeValid() {
            return moment(vm.concert.concert_door_time).isBefore(vm.concert.concert_start_time, "minutes");
        }

        function isConcertTimesValid() {
            if (vm.concert.concert_start_time && vm.concert.concert_end_time && vm.concert.concert_door_time) {
                return isConcertEndTimeValid() && isConcertDoorTimeValid();
            } else {
                return false;
            }
        }

        function lowFiFeeInfo() {
            dialog.info('low-fi-fee-info');
        }

        function royaltyFeeInfo() {
            dialog.info('royalties-info');
        }

        function currencyConversionFeeInfo() {
            dialog.info('currency-conversion-fee-info');
        }

        function privateConcertInfo() {
            dialog.info('private-concert-info');
        }

        function lowFiConditionsInfo(event) {
            event.preventDefault();
            dialog.info('low-fi-concert-conditions-info');
        }

        function noLowFiHostInfo() {
            dialog.info('no-low-fi-host-info');
        }

        function getPreviewState() {
            var params = {};
            params['concert_slug'] = vm.slug;

            var state = 'concert_preview';

            return $state.href(state, params);
        }

        function royaltyFreeToggle(init) {
            vm.royaltyFee = vm.royaltyFreeConcert ? 0 : 10;
            validate_percentage_division('concert_host_percentage');
            calculateShares();
            if (vm.royaltyFreeConcert && !init) {
                royaltyFeeInfo();
            }
        }

        function close() {
            if (vm.ConcertForm.$dirty) {
                dialog.prompt('unsaved-changes-prompt', function (response) {
                    if (response.confirm) {
                        leave();
                    }
                    if (response.alternative) {
                        save().then(leave);
                    }
                }, true);
            } else {
                leave();
            }
        }

        function leave() {
            $rootScope.no_scroll = false;
            if ($stateParams.band_slug) {
                return $state.go('musician', { band_slug: vm.band_slug });
            }
            if ($stateParams.space_slug) {
                return $state.go('host', { space_slug: vm.space_slug });
            }
            history.back();
        }

        function getContent() {
            return $http.get('api/concerts/' + vm.slug + '/')
                .then(function (response) {
                    if (!response.data.user_is_concert_admin) {
                        return $state.go('frontpage');
                    }
                    vm.concert = response.data;

                    if (vm.concert.concert_start_time) {
                        vm.concert.concert_date = dateParser.parseDate(response.data.concert_start_time);
                    } else if (vm.concert.concert_end_time) {
                        vm.concert.concert_date = dateParser.parseDate(response.data.concert_end_time);
                    } else if (vm.concert.concert_door_time) {
                        vm.concert.concert_date = dateParser.parseDate(response.data.concert_door_time);
                    }

                    vm.concert.concert_start_time = dateParser.parseDate(response.data.concert_start_time);
                    vm.concert.concert_end_time = dateParser.parseDate(response.data.concert_end_time);
                    vm.concert.concert_door_time = dateParser.parseDate(response.data.concert_door_time);

                    getFormattedDateTime();

                    if (vm.concert.space.space_slug === "") {
                        vm.no_host = true;
                    } else {
                        vm.space_slug = vm.concert.space.space_slug;
                        getSpaceInfo(vm.concert.space.space_slug).then();
                    }

                    vm.band_slug = vm.concert.band.band_slug;

                    getBandInfo(vm.concert.band.band_slug).then();

                    vm.concert.concert_host_percentage = vm.concert.concert_host_percentage.toString();

                    validate_percentage_division('concert_host_percentage');

                    if (vm.concert.concert_royalty_percentage == 0) {
                        vm.royaltyFreeConcert = true;
                        royaltyFreeToggle(true);
                    }

                    if (vm.concert.concert_published) {
                        vm.accept_conditions = true;
                    }

                    if (response.data.concert_mask_required) {
                        vm.concert.concert_mask_required = true
                    }
                    if (response.data.concert_corona_pass_required) {
                        vm.concert.concert_corona_pass_required = true
                    }
                    if (response.data.concert_corona_test_required) {
                        vm.concert.concert_corona_test_required = true
                    }

                    vm.lowFiFee = vm.concert.concert_lowfi_percentage;

                    makeConcertShadow();

                    calculateShares();

                    if (vm.concert.concert_currency_conversion_fee > 0) {
                        vm.currency_conversion = true;
                    }

                    vm.image_selected = vm.concert.band_image_hash ? true : false;
                    vm.published_image = vm.concert.band_image_hash;

                    if(vm.concert.fee_voucher_id) {
                        if (!vm.concert.concert_published) {
                            getFeeVoucher();
                        } else {
                            vm.voucher_added = true;
                        }
                    }

                });
        }

        function getCurrencies() {
            return $http.get('api/currencies/')
                .then(function (response) {
                    vm.currencies = response.data;
                });
        }

        function getUserHostAndMusicianProfiles() {
            return $http.get('api/users/user_affiliates/')
                .then(function (response) {
                    vm.user_bands = response.data.affiliates.band;
                    vm.user_hosts = response.data.affiliates.space;

                    if(!vm.user_bands && !vm.user_hosts){
                        $state.go('member');
                    }
                    vm.showCreateMusicianProfile = ($stateParams.space_slug && userHasNoMusicianProfile()) ? true : false;
                    vm.showCreateHostProfile = ($stateParams.band_slug && userHasNoHostProfile()) ? true : false;
                    vm.showCreateConcertForm = (vm.showCreateMusicianProfile === false && vm.showCreateHostProfile === false) ? true : false;
                    vm.showNoHostInfo = false;


                    vm.showMusicianInfo = ($stateParams.space_slug && !vm.showCreateMusicianProfile) ? true : false;
                    vm.showHostInfo = ($stateParams.band_slug && !vm.showCreateHostProfile) ? true : false;
                    if (vm.showMusicianInfo || vm.showHostInfo) {
                        vm.showCreateConcertForm = false;
                    }

                    if (vm.user_bands && !vm.user_hosts && !vm.concert.space_id) {
                        vm.user_bands.forEach(function (band) {
                            if (band.band_slug === vm.band_slug) {
                                vm.no_host = true;
                                if (!$stateParams.back_from_preview_or_save) {
                                    vm.showNoHostInfo = true;
                                }
                                vm.showCreateHostProfile = false;
                            }
                        })
                    }

                    if (vm.space_slug && vm.user_bands && vm.user_bands.length > 0 && vm.slug == "new") {
                        vm.band = vm.user_bands[0];
                        vm.concert.band_id = vm.band.band_id;
                        autofillMusician()
                    }
                    if (vm.band_slug && vm.user_hosts && vm.user_hosts.length > 0 && vm.slug == "new") {
                        vm.space = vm.user_hosts[0];
                        vm.concert.space_id = vm.space.space_id;
                        autofillHost();
                    }

                    if (vm.concert.concert_currency_conversion_fee == undefined && vm.band.band_admin_stripe_currency && vm.concert.concert_currency != vm.band.band_admin_stripe_currency) {
                        vm.currency_conversion = true;
                    } else if (!vm.concert.concert_published && vm.band.band_admin_stripe_currency && vm.concert.concert_currency != vm.band.band_admin_stripe_currency) {
                        vm.currency_conversion = true;
                    } else if (!vm.band.band_admin_stripe_currency) {
                        vm.currency_conversion = false;
                    }
                    validate_percentage_division('concert_host_percentage');

                    calculateShares();
                    if(vm.band.band_admin_stripe_verification_status != 'verified') {
                        $http.post('api/user/update_stripe/' + vm.band.band_admin + '/')
                            .then(function(response) {
                                if(response.data != false) {
                                    vm.band.band_admin_stripe_verification_status = response.data;
                                    $scope.$applyAsync();
                                }
                            });
                    }
                });
        }

        function getFeeVoucher() {
            var callback = function (response) {
                if (response.data.fee_voucher_error) {
                    if(vm.concert.fee_voucher_id) {
                        vm.concert.fee_voucher_id = null;
                    }
                    vm.voucher_error = response.data.fee_voucher_error;
                } else {
                    vm.voucher_error = null;
                    vm.fee_voucher_amount = response.data.amount;
                    vm.concert.fee_voucher_id = response.data.id;
                    feeVoucherCalculate();
                    vm.voucher_added = true;
                }

            };
            if (vm.concert.fee_voucher_id) {
                return $http.post('/app/api/fee_voucher/get_by_id/', { id: vm.concert.fee_voucher_id }).then(callback);
            } else {
                return $http.post('/app/api/fee_voucher/get/', { code: vm.code }).then(callback);
            }
        }

        function feeVoucherCalculate() {
            vm.concert.concert_band_percentage += vm.lowFiFee - vm.fee_voucher_amount;
            vm.lowFiFee = vm.fee_voucher_amount;
            calculateShares();
        }

        function save(stop_routing_to_new_instance, $event) { //Posts the data for the listing getting created
            if (!vm.validateDraft()) {
                return false;
            }

            if (!vm.no_host && !vm.concert.concert_address && !vm.concert.concert_city && !vm.concert.concert_zip) {
                vm.concert.concert_address = vm.space.space_address;
                vm.concert.concert_city = vm.space.space_city;
                vm.concert.concert_zip = vm.space.space_zip;
                vm.concert.concert_country = vm.space.space_country;
            }

            if (vm.no_host) {
                vm.concert.concert_currency = vm.band.band_price_currency;
            }

            vm.save_progress = 'saving';
            set_dates();

            var data = {
                concert_name: vm.concert.concert_name ? vm.concert.concert_name : vm.band.band_name,
                concert_published: vm.concert.concert_published,
                space_slug: (vm.space !== undefined ? vm.space.space_slug : ''),
                band_slug: vm.band.band_slug,
                concert_video: vm.concert.concert_video,
                concert_description_short: vm.concert.concert_description_short ? emojiReplacer.replaceEmojis(vm.concert.concert_description_short) : "",
                concert_description_long: vm.concert.concert_description_long ? emojiReplacer.replaceEmojis(vm.concert.concert_description_long) : "",
                concert_start_time: $filter('date')(vm.concert.concert_start_time, 'yyyy-MM-dd HH:mm') + ':00',
                concert_end_time: $filter('date')(vm.concert.concert_end_time, 'yyyy-MM-dd HH:mm') + ':00',
                concert_door_time: $filter('date')(vm.concert.concert_door_time, 'yyyy-MM-dd HH:mm') + ':00',
                concert_band_percentage: vm.currency_conversion ? vm.concert.concert_band_percentage + vm.currencyConversionFee : vm.concert.concert_band_percentage,
                concert_host_percentage: vm.concert.concert_host_percentage,
                concert_lowfi_percentage: vm.lowFiFee,
                concert_royalty_percentage: vm.royaltyFee,
                concert_currency_conversion_fee: vm.currency_conversion ? vm.currencyConversionFee : 0,
                concert_price: vm.concert.concert_price,
                concert_currency: vm.concert.concert_currency,
                concert_ticket_no: vm.concert.concert_ticket_no,
                concert_ticket_handling_automatic: vm.concert.concert_ticket_handling_automatic,
                concert_public: vm.concert.concert_public,
                concert_address: vm.concert.concert_address,
                concert_zip: vm.concert.concert_zip,
                concert_city: vm.concert.concert_city,
                concert_country: vm.concert.concert_country,
                concert_date: vm.concert.concert_date,
                concert_ad_booster: vm.concert.concert_ad_booster,
                moods: vm.concert.selected_moods,
                upload_image_slug: vm.upload_image_slug,
                band_image_hash: vm.concert.band_image_hash,
                fee_voucher_id: vm.concert.fee_voucher_id,
                concert_mask_required: vm.concert.concert_mask_required,
                concert_corona_pass_required: vm.concert.concert_corona_pass_required,
                concert_corona_test_required: vm.concert.concert_corona_test_required,
                concert_additional_purchase_fee: vm.concert.concert_additional_purchase_fee,
                concert_additional_purchase_description: vm.concert.concert_additional_purchase_description
            };
            if (vm.published_image !== vm.concert.band_image_hash) {
                data.old_image = vm.published_image;
            }

            if (vm.slug === 'new') {
                return $http.post('api/concerts/', data)
                    .then(function (response) {
                        vm.save_progress = 'success';
                        if (cache.exists('upcoming_concerts')) {
                            cache.reset('upcoming_concerts');
                        }
                        vm.slug = response.data.concert_slug;
                        /* if (!stop_routing_to_new_instance && response.data !== undefined && response.data.concert_slug !== undefined && vm.concert.concert_published != 1) {
                            return $state.go('member')
                        } */
                    });
            } else {
                return $http.patch('api/concerts/' + vm.concert.concert_slug + '/', data)
                    .then(function (response) {
                        if (cache.exists('upcoming_concerts')) {
                            cache.reset('upcoming_concerts');
                        }
                        vm.save_progress = 'success';
                        vm.ConcertForm.$setPristine();
                        makeConcertShadow();
                        promoModule.createAllBanners(vm.concert, { force: true });
                        /* if (vm.concert.concert_published != 1) {
                            return $state.go('member')
                        } */
                    });
            }
        }

        function validateDraft() {
            var valid = true;
            vm.showNoHostError = false;
            vm.showNoMusicianError = false;
            vm.showGeneralError = false;

            if (angular.equals(vm.space, {}) && !vm.no_host) {
                valid = false;
                vm.showNoHostError = true;
                vm.showGeneralError = true;
            }
            if (angular.equals(vm.band, {})) {
                valid = false;
                vm.showNoMusicianError = true;
                vm.showGeneralError = true;
            }

            return valid
        }

        function validatePublish() {
            var valid = true;

            if (angular.equals(vm.space, {}) && (!vm.concert.city_zip || !vm.concert.concert_address)) valid = false;
            if (angular.equals(vm.band, {})) valid = false;
            if (!vm.concert.band_image_hash) valid = false;
            if (!vm.concert.concert_description_short || vm.concert.concert_description_short.length < 80 || vm.concert.concert_description_short.length > 165) valid = false;
            if (!vm.concert.concert_description_long || vm.concert.concert_description_long.length < 100 || vm.concert.concert_description_long.length > 1200) valid = false;
            if (!vm.isConcertTimesValid()) valid = false;
            if (vm.concert.concert_host_percentage > 0 && vm.space && !vm.space.space_admin_has_payment_info) valid = false;
            if (vm.band && !vm.band.band_admin_has_payment_info) valid = false;

            return valid
        }

        function getCurrencyMinimumPrice(currency) {
            if (!currency) return 0;
            var minimum_price = 0;
            switch (currency.toLowerCase()) {
                case 'dkk':
                    minimum_price = 150;
                    break;
                case 'sek':
                    minimum_price = 150;
                    break;
                case 'gbp':
                    minimum_price = 12;
                    break;
            }

            return minimum_price;
        }

        function publish() {
            if (!formIsValid() || !validatePublish()) {
                angular.forEach(vm.ConcertForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                vm.form_validated = true;
            } else {
                // dialog.prompt('publish-concert-prompt', function (response) {
                //     if (response.confirm) {
                save().then(function () {
                    vm.concert_link = vm.server_name + "/" + $stateParams.language + "/concert/" + vm.slug;
                    vm.mailto_link = "mailto:" + "" +
                        "?subject=" + vm.concert.concert_name + " - Be My Concert" +
                        "&body=" + vm.concert_link;
                    vm.showCreateConcertForm = 0;
                    vm.showConcertPublishedInfoBox = 1;
                    $state.go('concert_contract', { concert_slug: vm.slug });
                });
                //}
                // });
            }
        }

        function saveDraft() {
            save().then(function () {
                $state.go('member');
            });
        }

        function softDelete() {
            dialog.prompt('delete-draft-prompt', function (response) {
                if (response.confirm) {
                    $http.delete('api/concerts/' + vm.slug + '/')
                        .then(function (response) {
                            if (cache.exists('upcoming_concerts')) {
                                cache.reset('upcoming_concerts');
                            }
                            leave();
                        });
                }
            });
        }

        function makeConcertShadow() {
            vm.concert_shadow = angular.copy(vm.concert);
        }

        function validate_percentage_division(type) {
            switch (type) {
                case 'concert_band_percentage':
                    vm.concert.concert_host_percentage = 100 - vm.concert.concert_band_percentage - vm.lowFiFee - vm.royaltyFee;
                    break;
                case 'concert_host_percentage':
                    vm.concert.concert_band_percentage = 100 - vm.concert.concert_host_percentage - vm.lowFiFee - vm.royaltyFee - (vm.currency_conversion ? vm.currencyConversionFee : 0);
                    break;
            }

            if (vm.concert.concert_host_percentage + vm.concert.concert_band_percentage !== 100) return false;

            return true;
        }

        function formIsValid() {
            return vm.ConcertForm.$valid && vm.concert.band_image_hash;
        }

        function set_dates() {
            if (vm.concert.concert_end_time !== undefined) vm.concert.concert_end_time.setFullYear(vm.concert.concert_date.getFullYear(), vm.concert.concert_date.getMonth(), vm.concert.concert_date.getDate());
            if (vm.concert.concert_door_time !== undefined) vm.concert.concert_door_time.setFullYear(vm.concert.concert_date.getFullYear(), vm.concert.concert_date.getMonth(), vm.concert.concert_date.getDate());
            if (vm.concert.concert_start_time !== undefined) vm.concert.concert_start_time.setFullYear(vm.concert.concert_date.getFullYear(), vm.concert.concert_date.getMonth(), vm.concert.concert_date.getDate());
        }

        function calculateShares() {
            vm.shares.lowFi = vm.concert.concert_price ? (vm.concert.concert_price * vm.lowFiFee) / 100 : 0;
            vm.shares.royalty = vm.concert.concert_price ? (vm.concert.concert_price * vm.royaltyFee) / 100 : 0;
            vm.shares.host = vm.concert.concert_price ? (vm.concert.concert_price * vm.concert.concert_host_percentage) / 100 : 0;
            vm.shares.musician = vm.concert.concert_price ? (vm.concert.concert_price * vm.concert.concert_band_percentage) / 100 : 0;
            vm.shares.currencyConversion = (vm.concert.concert_price && vm.currency_conversion) ? (vm.concert.concert_price * vm.currencyConversionFee) / 100 : 0;
        }

        function showPreview() {
            if (!validateDraft()) { return }
            var state = 'concert_preview';
            var params = {};
            params['concert_slug'] = vm.slug;

            save().then(function (response) {
                params['concert_slug'] = vm.slug;
                $rootScope.no_scroll = false;
                $state.go(state, params);
            });
        }

        function hideSplashAndShowForm() {
            vm.showNoHostInfo = false;
            vm.showHostInfo = false;
            vm.showMusicianInfo = false;
            vm.showCreateConcertForm = true;
        }

        function selectImage(image) {
            vm.concert.band_image_hash = image;
            vm.image_selected = true;
        }

        function userHasNoMusicianProfile() {
            if (vm.user_bands === undefined || vm.user_bands.length == 0) {
                return true;
            }
            if (vm.user_bands.length > 0) {
                return false;
            }
        }

        function removeNoScroll() {
            $rootScope.no_scroll = false;
        }

        function userHasNoHostProfile() {
            if (vm.user_hosts === undefined || vm.user_hosts.length == 0) {
                return true;
            }
            if (vm.user_hosts.length > 0) {
                return false;
            }
        }

        function copyLink() {
            navigator.clipboard.writeText(vm.concert_link);
            vm.link_copied = 1;
        }

        function closeSharePopup() {
            vm.link_copied = 0;
            vm.show_share_popup = 0;
        }

        function getSpaceInfo(space_slug) {
            if (!space_slug) {
                space_slug = vm.space.space_slug;
            }
            return $http.get('api/spaces/' + space_slug + '/')
                .then(function (response) {
                    vm.space = response.data;
                });
        }

        function getFormattedDateTime() {
            vm.start_time = $filter('date')(vm.concert.concert_start_time, 'HH:mm');
            vm.end_time = $filter('date')(vm.concert.concert_end_time, 'HH:mm');
            vm.door_time = $filter('date')(vm.concert.concert_door_time, 'HH:mm');
            vm.date = $filter('date')(vm.concert.concert_start_time, 'yyyy-MM-dd');
        }

        function getCountryAdjective() {
            if (vm.concert.concert_currency == 'sek') {
                vm.country_name_adjective_en = 'swedish'
                vm.country_name_adjective_da = 'svensk'
                vm.country_name_adjective_se = 'svenska'
            } else {
                vm.country_name_adjective_en = 'danish'
                vm.country_name_adjective_da = 'dansk'
                vm.country_name_adjective_se = 'danska'
            }
        }

        function getBandInfo(band_slug) {
            if (!band_slug) {
                band_slug = vm.band.band_slug;
            }
            return $http.get('api/bands/' + band_slug + '/')
                .then(function (response) {
                    vm.band = response.data;
                    vm.band_images = [];
                    vm.band_images.push(vm.band.primary_image)
                    vm.band_images = vm.band_images.concat(vm.band.secondary_images)
                    if(vm.band.band_admin_stripe_verification_status != 'verified') {
                        $http.post('api//user/update_stripe/' + vm.band.band_admin + '/')
                            .then(function(response) {
                                if(response.data != false) {
                                    vm.band.band_admin_stripe_verification_status = response.data;
                                    $scope.$applyAsync();
                                }
                            });
                    }
                });
        }
    }
})();
